import { ITag } from '@forwardflow/store/onboardingStoreV2'
import {
   IStageMapGroup,
   IStageMappingSubGroup,
   ITempStageGroup,
   TStageGroupId,
   TStopStageKey,
} from '@forwardflow/types/onboarding'

export const transforStageMappingData = (data: ITempStageGroup[]) => {
   const stageMappings: IStageMapGroup[] = []
   const parentGroups = data.filter((item) => item.parentGroupId === null)
   parentGroups.forEach((item) => {
      const stages = item?.stageOrTags?.filter((item) => item.type === 'stage')
      const tags = item?.stageOrTags?.filter((item) => item.type === 'tag')

      stageMappings.push({
         group: item.groupId as TStageGroupId,
         stages: stages,
         tags: tags as ITag[],
         ...(item.type ? { type: item?.type } : {}),
      })
   })

   const childGroups = data
      .filter((item) => item.parentGroupId === 'ff-stopped')
      ?.map((i) => ({
         key: i.groupId as TStopStageKey,
         stages: i?.stageOrTags?.filter((item) => item.type === 'stage'),
         tags: i?.stageOrTags?.filter((item) => item.type === 'tag'),
      }))

   stageMappings.push({
      group: 'ff-stopped',
      types: childGroups as IStageMappingSubGroup[],
   })
   return stageMappings
}
